export default "__VITE_ASSET__DJn1kRjq__"